import { create } from "zustand";
import { persist } from "zustand/middleware";

export type UiLanguage = "fr" | "en" | "zh";
export type UiTheme = "light" | "dark";

interface UiState {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  theme: UiTheme;
  toggleTheme: () => void;
  setTheme: (theme: UiTheme) => void;
  language: UiLanguage;
  /**
   * Ne pas appeler directement pour changer la langue de l'app — passer par
   * i18n.changeLanguage() (la synchro i18n → store est automatique via
   * languageChanged). Ce setter est un détail interne de synchronisation.
   */
  setLanguage: (language: UiLanguage) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      theme: "light",
      toggleTheme: () =>
        set((s) => ({ theme: s.theme === "dark" ? "light" : "dark" })),
      setTheme: (theme) => set({ theme }),
      language: "fr",
      setLanguage: (language) => set({ language }),
    }),
    { name: "flash-pay-ui" }
  )
);

const applyThemeClass = (theme: UiTheme) => {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("dark", theme === "dark");
};

// Application initiale (post-réhydratation persist) puis à chaque changement.
applyThemeClass(useUiStore.getState().theme);
useUiStore.subscribe((state) => applyThemeClass(state.theme));
